// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__NuE14","validationTips":"StatementDescriptor_validationTips__3s9n6"};